import { render, staticRenderFns } from "./LoansMoreDetails.vue?vue&type=template&id=7d215336&"
import script from "./LoansMoreDetails.vue?vue&type=script&lang=js&"
export * from "./LoansMoreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports